import { createSelector } from 'reselect';

const videoViewerState = (state) => state.videoViewer;

export const getInteractionList = createSelector(
  videoViewerState,
  (videoViewer) => videoViewer.node?.interactions || []
);
